import { DotsThreeVerticalIcon } from '@phosphor-icons/react';
import { useQueryClient } from '@tanstack/react-query';
import { is } from 'date-fns/locale';
import { toast } from 'sonner';
import colors from 'tailwindcss/colors';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useApiMutation } from '@/modules/common';

interface OrdersTableActionsProps {
  eventId: string;
  orderId: string;
  imageUrl: string;
  onSendSms: () => void;
}

export function OrdersTableActions({
  eventId,
  orderId,
  imageUrl,
  onSendSms,
}: OrdersTableActionsProps) {
  const downloadImageMutation = useApiMutation<void, { downloadUrl: string }>(
    `/events/${eventId}/orders/${orderId}/image-download-url`,
    {
      method: 'GET',
    },
    {
      onSuccess: (res) => {
        if (res.downloadUrl) {
          const link = document.createElement('a');
          link.href = res.downloadUrl;
          link.download = res.downloadUrl; // Specify the desired file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild className="ml-6">
          <Button variant="ghost" size="icon" data-testid="participant-actions">
            <DotsThreeVerticalIcon size={28} color={colors.zinc[400]} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={onSendSms}>Send sms</DropdownMenuItem>
          <Tooltip>
            <TooltipTrigger asChild>
              <DropdownMenuItem
                onClick={
                  imageUrl ? () => downloadImageMutation.mutate() : undefined
                }
              >
                Download Image
              </DropdownMenuItem>
            </TooltipTrigger>
            <TooltipContent
              side="left"
              style={{ display: !!imageUrl ? 'none' : undefined }}
            >
              Image unavailable
            </TooltipContent>
          </Tooltip>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
